jQuery(function ($) {

    const elements = $('.platser-filter-select');

    elements.each(function (index, el) {
        new Choices(el, {
                placeholder: true,
                silent: true,
                searchPlaceholderValue: '',
                itemSelectText: '',
                noResultsText: $(el).data('no-results'),
                shouldSort: false,
                position: "bottom",
                searchResultLimit: 100,
                searchFields: ['label'],
                fuseOptions: {
                    includeMatches: true,
                    threshold: 0.0,
                    tokenize: true,
                }
            }
        );
    }).change( function(){
        let geoParam = $("#filter-row-data").data('geo-param');
        let newL = $("[name=city_select]").val();
        let newT = $("[name=loctype_select]").val();
        let newFuntype = $("[name=funtype_select]").val();
        // console.log('/'+ (newT ==='' ? 'ordna-begravning/platser/' : newT + '/') + (newL ==='' ? '' : newL + '/') + (newFuntype ==='' ? '' : newFuntype + '/') + geoParam;
        window.location.href = '/'+ (newT ==='' ? 'ordna-begravning/platser/' : newT + '/') + (newL ==='' ? '' : newL + '/') + (newFuntype ==='' ? '' : newFuntype + '/') + geoParam;
    });

    jQuery('#toggleFilter').on('click', function() {
        let filter = document.getElementById("filter-row-data");
        filter.classList.toggle('toggle');
        const tglFilter = document.getElementById("toggleFilter");
        const clrFilter = document.getElementById("clearFilter");
        let dataFilterCounter = document.getElementById("toggleFilter").dataset.filterCounter;
        console.log("dataFilterCounter", typeof dataFilterCounter);
        if (filter.classList.contains("toggle")) {
            tglFilter.innerHTML = "Stäng";
            let inputHeight = jQuery('#filter-row-data').offset().top - 80;
            jQuery("html, body").animate({ scrollTop: inputHeight}, 300);
            clrFilter.style.display = "block";
            return false;
        }else{
            tglFilter.innerHTML = dataFilterCounter !== "0" ? "Filtrera (" + dataFilterCounter + ")" : "Filtrera";
            // tglFilter.innerHTML = "Filtrera (" + dataFilterCounter + ")";
            clrFilter.style.display = "none";
        }
    })

    jQuery('#clearFilter').on('click', function() {
        let dataFilterCounter = document.getElementById("toggleFilter").dataset.filterCounter;
        if (dataFilterCounter !== "0") {
            window.location.href = "/ordna-begravning/platser/";
        }
    })
});

